module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexRow"
  }, [(!_vm.isLoggedIn) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n    Login\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "profile-data flexRow",
    on: {
      "click": _vm.logout
    }
  }, [(!_vm.isMobile()) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": _vm.photoURL
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16141ba8!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/UserProfileLink.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-16141ba8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/UserProfileLink.vue
// module chunks = 0